import "reflect-metadata";
import "./assets/styles/index.css";
import "reflect-metadata";
import "@pacificoseguros/pixie/variables.css";

import { AzureProvider, Msal, StorageType } from "@pacificoseguros/security";

import App from "./containers/app/app";
import { Environment } from "@pacificoseguros/tools";
import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";

const msal = new Msal({
	clientId: Environment.string(process.env.REACT_APP_MSAL_CLIENT_ID),
	authority: Environment.string(process.env.REACT_APP_MSAL_AUTHORITY),
	redirectUri: Environment.string(process.env.REACT_APP_MSAL_REDIRECTURI),
	storage: StorageType.sessionStorage,
	redirectDefault: "/",
});
ReactDOM.render(
	<React.StrictMode>
		<AzureProvider msalInstance={msal}>
			<App />
		</AzureProvider>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
